export const AppDateFormat = 'MM/dd/yyyy';
export const AppTimeFormat = 'h:mm a';
